export { default } from "./DialogueSkeleton";
